const FULFILLMENT_URL_PARAM = 'fulfillment';
const TOKEN_URL_PARAM = 'refundToken';
const BOOKING_ID_URL_PARAM = 'booking';

export interface RefundUrlParams {
  bookingId: string;
  fulfillment?: string;
  token?: string;
}

const normalize = (value: string | null): string | undefined =>
  value?.trim() || undefined;

/**
 * Reads the refund deep-link parameters (`booking`, `fulfillment`, `refundToken`)
 * from a URL query string. Defaults to the current location so callers can invoke
 * it with no arguments; an explicit string is accepted for testing.
 */
export const parseRefundUrlParams = (
  search: string = window.location.search
): RefundUrlParams => {
  const searchParams = new URLSearchParams(search);

  return {
    bookingId: normalize(searchParams.get(BOOKING_ID_URL_PARAM)) ?? '',
    fulfillment: normalize(searchParams.get(FULFILLMENT_URL_PARAM)),
    token: normalize(searchParams.get(TOKEN_URL_PARAM)),
  };
};
